export function downloadAsCSV(data: any[], filename: string) {
    // Convert array of objects to CSV string
    const csvContent = [
      // Header row
      Object.keys(data[0]).join(','),
      // Data rows
      ...data.map(item => Object.values(item).map(value => 
        // Escape special characters and wrap in quotes if needed
        typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))
          ? `"${value.replace(/"/g, '""')}"` 
          : value
      ).join(','))
    ].join('\n');
  
    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }